.ControlHeader1388303002__root {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  user-select: none;
}

.ControlHeader1388303002__prefix,
.ControlHeader1388303002__suffix {
  display: flex;
}

.ControlHeader1388303002__suffix {
  margin-inline-start: auto;
}

.ControlHeader1388303002__info {
  -st-states: visible;

  opacity: 0;
}

.ControlHeader1388303002__info:focus-visible,
.ControlHeader1388303002__info.ControlHeader1388303002--visible {
  opacity: 1;
}

/* st-namespace-reference="../../../../src/atoms/ControlHeader/ControlHeader.st.css" */